import styled from 'styled-components';
import { ModalTextParagraph, StyledModal } from '../Modals-styled';


export const CheckoutModal = styled(StyledModal)`
	.ant-modal-content .ant-modal-close-x {
		display: none;
	}

	.ant-modal-body .anticon-loading-3-quarters {
		padding-right: 5px;
	}
`;

export const CheckoutModalLinkParagraph = styled(ModalTextParagraph)`
	font-size: 0.8rem;
	padding-top: 1rem;
`;